<template>
    <main class="home-wrapper">
        <nav-bar></nav-bar>
        <div class="home h-100 overflow-auto">
            <router-view></router-view>
        </div>
    </main>
</template>

<script>
    import NavBar from "../components/layout/NavBar";
    export default {
        name: "Home",
        components: {
            NavBar

        },
        data () {
            return {

            };
        },
        computed: {

        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
    .home-wrapper {
        height: 100vh;

        .home {
            padding-top: 3rem;
        }
    }
</style>
